import BrandingActionCard from "../_local/components/NewCards/BrandingActionCard";
import React from "react";


interface Material {
    MATERIAL_IMAGE?: { selectedImage: string };
    MATERIAL_NAME?: string;
    MATERIAL_TYPE?: string;
    MATERIAL_DESCRIPTION?: string;
}

const BrandingPreview = () => {
    const materialsData: Material[] = JSON.parse(sessionStorage.getItem("materials")) || [];

    if (!materialsData || materialsData.length === 0) {
        return <p className="text-gray-500">No branding materials added yet.</p>;
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {materialsData.map((material, index) => (
                <BrandingActionCard
                    key={`material-preview-${index}`}
                    element={material}
                    // handleOpenDrawer={() => {}} // No operation in preview
                    // onDelete={() => {}} // No operation in preview
                    isError={false} // Default value for preview
                />
            ))}
        </div>
    );
};

export default BrandingPreview;